import React from "react";
import { Helmet } from "react-helmet";
import {
  seo,
  socialMediaLinks,
  experience,
  contactPageData,
  certifications,
} from "../../portfolio.js";

function SeoHeader() {
  // Filter social links for schema's sameAs
  let sameAs = socialMediaLinks
    .filter(
      (media) =>
        !(media.link.startsWith("tel") || media.link.startsWith("mailto"))
    )
    .map((media) => media.link);

  // Get email from socialMediaLinks
  let mail =
    socialMediaLinks
      .find((media) => media.link.startsWith("mailto"))
      ?.link.substring("mailto:".length) || "daniel.constante2086@gmail.com"; // Fallback email

  // Get latest job
  let job = experience.sections?.find((section) => section.work)
    ?.experiences?.[0] || {
    title: "Principal Full Stack Software Engineer",
    company: "Locums.com",
  };

  // Limit credentials to key ones for schema brevity
  let credentials = certifications.certifications
    .filter((cert) =>
      [
        "Full-Stack & Mobile Development",
        "M.S. in Software Engineering(Domain-Driven Design)",
        "Cloud Practitioner",
      ].includes(cert.title)
    )
    .map((certification) => ({
      "@context": "https://schema.org",
      "@type": "EducationalOccupationalCredential",
      url: certification.certificate_link,
      name: certification.title,
      description: certification.subtitle,
    }));

  const data = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Daniel Constante", // Hardcode for consistency
    url: seo?.og?.url || "https://danielconstante.netlify.app/",
    email: mail,
    telephone: contactPageData.phoneSection?.subtitle || "", // Ensure fallback if undefined
    sameAs: sameAs,
    jobTitle: job.title,
    description:
      "Principal Full Stack Software Engineer based in Dallas/DFW, specializing in React, UI/UX, and scalable web applications.",
    worksFor: {
      "@type": "Organization",
      name: job.company,
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: contactPageData.addressSection?.locality || "Dallas",
      addressRegion: contactPageData.addressSection?.region || "Texas",
      addressCountry: contactPageData.addressSection?.country || "USA",
      postalCode: contactPageData.addressSection?.postalCode || "76227",
      streetAddress: contactPageData.addressSection?.streetAddress || "",
    },
    hasCredential: credentials,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="author" content="Daniel Constante" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:title" content={seo.og.title} />
      <meta property="og:description" content={seo.og.description} />
      <meta property="og:type" content={seo.og.type} />
      <meta property="og:url" content={seo.og.url} />
      <meta property="og:image" content={seo.og.image} />
      <meta property="og:site_name" content={seo.og.site_name} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={seo.twitter.card} />
      <meta name="twitter:title" content={seo.twitter.title} />
      <meta name="twitter:description" content={seo.twitter.description} />
      <meta name="twitter:image" content={seo.twitter.image} />
      <meta name="twitter:creator" content={seo.twitter.creator} />

      {/* Schema */}
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export default SeoHeader;
